import { getLogger } from '../../../../infrastructure/logger';

const MISSING_KEY_TYPE = 'MISSING_I18N_KEY';

export const logMissingKeys = (missingKeys: string[]) => {
  getLogger().error(MISSING_KEY_TYPE, {
    missingKeys,
  });
};
